import get from 'lodash/get';
import replace from 'lodash/replace';
import { copAccountTypes, copReasonCodes } from '../../config';

export const getCustomerId = (state) => get(state, 'cop.customerId', '');
export const getBeneficiaryId = (state) => get(state, 'cop.beneficiaryId', '');
export const getCustomerType = (state) => get(state, 'cop.customerType', '');
export const getAccountType = (state) => get(state, 'cop.accountType', '');
export const getAccountIdentification = (state) =>
	get(state, 'cop.sortCode', '').replace(/-/g, '') + get(state, 'cop.accountNumber', '');
export const getAccountName = (state) => get(state, 'cop.accountName', '');
export const getRef = (state) => get(state, 'cop.reference', '');
export const getCopyText = (state) => get(state, 'cop.result.account_name_verification.copytext');
export const getCopPage = (state) => get(state, 'cop.page');
export const getReasonCode = (state) =>
	get(state, 'cop.result.account_name_verification.verification_report.reason_code');
export const getMatchedAccountName = (state) =>
	get(state, 'cop.result.account_name_verification.verification_report.name');
export const wasLastOutcomeCloseMatch = (state) =>
	Object.keys(copReasonCodes.closeMatch).includes(
		get(state, 'cop.result.account_name_verification.verification_report.reason_code')
	);

export const getCloseMatchDetails = (state) => {
	const currentDetails = get(state, 'cop', {});
	const reasonCode = getReasonCode(state);
	const matchedAccountName = getMatchedAccountName(state);

	switch (reasonCode) {
		case copReasonCodes.closeMatch.MBAM:
			return { ...currentDetails, accountName: matchedAccountName };
		case copReasonCodes.closeMatch.PANM:
			return { ...currentDetails, accountType: copAccountTypes.Personal };
		case copReasonCodes.closeMatch.BAMM:
			return { ...currentDetails, accountType: copAccountTypes.Business, accountName: matchedAccountName };
		case copReasonCodes.closeMatch.BANM:
			return { ...currentDetails, accountType: copAccountTypes.Business };
		case copReasonCodes.closeMatch.PAMM:
			return { ...currentDetails, accountType: copAccountTypes.Personal, accountName: matchedAccountName };
		default:
			return null;
	}
};

export const getCloseMatchFields = (state) => {
	const reasonCode = getReasonCode(state);
	const matchedAccountName = getMatchedAccountName(state);
	const accountName = getAccountName(state);

	switch (reasonCode) {
		case copReasonCodes.closeMatch.MBAM:
			return { accountName, matchedAccountName };
		case copReasonCodes.closeMatch.PANM:
			return { accountType: copAccountTypes.Business, matchedAccountType: copAccountTypes.Personal };
		case copReasonCodes.closeMatch.BAMM:
			return {
				accountType: copAccountTypes.Personal,
				matchedAccountType: copAccountTypes.Business,
				accountName,
				matchedAccountName,
			};
		case copReasonCodes.closeMatch.BANM:
			return { accountType: copAccountTypes.Personal, matchedAccountType: copAccountTypes.Business };
		case copReasonCodes.closeMatch.PAMM:
			return {
				accountType: copAccountTypes.Business,
				matchedAccountType: copAccountTypes.Personal,
				accountName,
				matchedAccountName,
			};
		default:
			return {};
	}
};

export const getCopResult = (state) => {
	const response = get(state, 'cop.result.account_name_verification.verification_report', undefined);
	if (!response) return undefined;
	const result = {
		cop_reason_code: response.reason_code,
		...(response.hasOwnProperty('matched') && { cop_matching_outcome: response.matched }),
		reason_code_description: response.reason_code_description,
		matching_outcome: response.matching_outcome,
	};

	const payeeName = getAccountName(state);
	const payeeType = getAccountType(state);
	return { result, payeeName, payeeType };
};
